// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo_logoContainer__VxMZp","logoImage":"Logo_logoImage__bDD5B"};